import React, {ReactNode, useEffect, useState} from 'react';
import EstoreYouMayLike from '@wearesection/bandai-react-components/organisms/EStoreYouMayLike';
import {Box} from '@mui/material';
import {IRelatedGameCard} from '@wearesection/bandai-react-components/organisms/EStoreYouMayLike/RelatedGameCard';
import {
  convertToSlug,
  GetRouter,
  handleConvertToLocaleContentful,
  handleRenderPrice,
} from '~/utils';
import {getDataGame} from './get-data-game';
import productsApi from '~/pages/api/services/products-api';
import {PLACEHOLDER_IMG} from '~/constants';
import RenderNextImage from '../../atoms/render-next-image';
import {handleFormatPlatforms} from '~/pages/store/games/index.page';
import {usePageSetting} from '~/providers/page-context.provider';
import RenderNextLink from '../../atoms/render-next-link';

type IProps = {
  title: string;
  background?: string;
  isShow?: boolean;
  listIDRelated?: string[];
  listProduct?: any[];
  getById?: boolean;
  loading?: boolean;
};
export default function EStoreYouMayLikeOrganisms(props: IProps) {
  const {isShow = true, listIDRelated = [], getById = false, loading, listProduct} = props;
  const {locale} = GetRouter();
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};
  const [listThumbnail, setListThumbnail] = useState<IRelatedGameCard[]>([]);

  const handleGetData = async (listSku?: any[], listImgForSku?: any[], listID?: string[]) => {
    try {
      await productsApi
        .getListProductsForSKU(
          listID ? {id: listID?.join(',')} : {sku: listSku?.join(',')},
          handleConvertToLocaleContentful(locale as string)
        )
        .then((res: any) => {
          if (res?.status !== 200) {
            throw res;
          }
          const {data} = res?.data;
          if (data?.length) {
            const newListThumbnail: any[] = [];
            if (listID?.length) {
              (data ?? []).map((item: any) => {
                const newItem: any = {
                  id: item?.id,
                  title: item?.title,
                  mainImage: item?.mainImage || PLACEHOLDER_IMG,
                  mainImageNext: (
                    <RenderNextImage
                      src={item?.mainImage || PLACEHOLDER_IMG}
                      width={300}
                      height={200}
                    />
                  ),
                  isMerchandise: item?.isMerchandise ?? false,
                  href: item?.isMerchandise
                    ? `/store/merchandise/${convertToSlug(item?.title)}`
                    : `/store/game/${convertToSlug(item?.title)}`,
                  nextLink: (href: string, child: ReactNode) => (
                    <RenderNextLink href={href} child={child} />
                  ),
                  listIcon: item?.platforms ? handleFormatPlatforms(item?.platforms) : [],
                  valuePrice: {
                    label: dataTranslation['product-from'] || '',
                    price: `${handleRenderPrice(
                      item?.sale_price || item?.default_price || '00',
                      null,
                      locale
                    )}`,
                    priceOld:
                      item?.sale_price === item?.default_price
                        ? ''
                        : `${handleRenderPrice(item?.default_price || '00', null, locale)}`,
                  },
                };
                newListThumbnail.push(newItem);
              });
            } else {
              (listImgForSku ?? []).map((item: any) => {
                const itemBg = data.find((itemBg: any) => itemBg?.sku === item?.sku);
                if (itemBg) {
                  const newItem: any = {
                    id: itemBg?.id,
                    title: itemBg?.title,
                    mainImage: item?.image || PLACEHOLDER_IMG,
                    mainImageNext: (
                      <RenderNextImage
                        src={item?.image || PLACEHOLDER_IMG}
                        width={300}
                        height={200}
                      />
                    ),
                    href: itemBg?.isMerchandise
                      ? `/store/merchandise/${convertToSlug(itemBg?.title || '')}`
                      : `/store/games/${convertToSlug(itemBg?.title || '')}`,
                    nextLink: (href: string, child: ReactNode) => (
                      <RenderNextLink href={href} child={child} />
                    ),
                    listIcon: itemBg?.platforms?.length
                      ? handleFormatPlatforms(itemBg?.platforms)
                      : [],
                    valuePrice: {
                      label: dataTranslation['product-from'] || '',
                      price: `${handleRenderPrice(
                        itemBg?.sale_price || itemBg?.default_price || '00',
                        null,
                        locale
                      )}`,
                      priceOld:
                        itemBg?.sale_price === itemBg?.default_price
                          ? ''
                          : `${handleRenderPrice(itemBg?.default_price || '00', null, locale)}`,
                    },
                  };
                  newListThumbnail.push(newItem);
                }
              });
            }

            setListThumbnail(newListThumbnail);
          }
        })
        .catch(() => {});
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetDataOnContentFull = async () => {
    const listItem = await getDataGame(handleConvertToLocaleContentful(locale as string));
    if (listItem?.length) {
      const listSku = listItem.map((item: any) => item?.bcProductReference);
      const listImgForSku = listItem.map((item: any) => {
        return {
          sku: item?.bcProductReference,
          image: item?.mastheadBackgroundImage?.media?.url || PLACEHOLDER_IMG,
          description: item?.overviewDescription,
          videoId: item?.mastheadBackgroundImage?.videoEmbed || '',
        };
      });

      if (listSku.length) {
        handleGetData(listSku, listImgForSku);
      }
    }
  };

  useEffect(() => {
    if (Object.keys(dataTranslation)?.length) {
      if (getById) {
        if (listProduct?.length) {
          setListThumbnail(listProduct);
          return;
        }
        if (listIDRelated.length) {
          handleGetData([], [], listIDRelated);
        }
        return;
      }
      if (!listThumbnail?.length) {
        handleGetDataOnContentFull();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataTranslation, listIDRelated, getById, listProduct]);

  return (
    <Box>
      {!!listThumbnail.length && (
        <Box
          sx={{
            padding: isShow
              ? {
                  xs: '72px 0px',
                  md: '40px 0px',
                }
              : {},
            background: props?.background || '#fff',
          }}
        >
          {isShow && !loading && (
            <EstoreYouMayLike
              title={props?.title}
              listThumbnail={listThumbnail}
              locale={`${locale}`.toLowerCase()}
            />
          )}
        </Box>
      )}
    </Box>
  );
}
